<template>
  <section class="relative py-4 pt-8 px-4 sm:px-8 xl:px-12 overflow-hidden bg-white">
    <div class="max-w-[1400px] mx-auto relative z-10">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
        
        <!-- Stat 1 -->
        <div class="group flex flex-col items-center text-center p-8 sm:p-10 rounded-3xl bg-gray-50 border border-gray-100 shadow-sm transition-all duration-500 transform hover:-translate-y-2 hover:shadow-md hover:bg-white">
          <div class="relative z-10 flex flex-col items-center">
            <div class="w-14 h-14 mb-6 rounded-2xl bg-blue-100/50 text-blue-600 flex items-center justify-center group-hover:scale-110 group-hover:bg-blue-600 group-hover:text-white group-hover:shadow-lg group-hover:shadow-blue-600/20 group-hover:-rotate-3 transition-all duration-500">
              <TrendingUp class="w-6 h-6" />
            </div>
            <span class="block text-5xl md:text-6xl font-extrabold text-gray-900 tracking-tight tabular-nums mb-3">15k<span class="text-blue-600 ml-1">+</span></span>
            <span class="block text-gray-500 font-normal leading-relaxed max-w-[220px] mx-auto">Applications tracked by ambitious engineers</span>
          </div>
        </div>

        <!-- Stat 2 -->
        <div class="group flex flex-col items-center text-center p-8 sm:p-10 rounded-3xl bg-gray-50 border border-gray-100 shadow-sm transition-all duration-500 transform hover:-translate-y-2 hover:shadow-md hover:bg-white">
          <div class="relative z-10 flex flex-col items-center">
            <div class="w-14 h-14 mb-6 rounded-2xl bg-indigo-100/50 text-indigo-600 flex items-center justify-center group-hover:scale-110 group-hover:bg-indigo-600 group-hover:text-white group-hover:shadow-lg group-hover:shadow-indigo-600/20 group-hover:rotate-3 transition-all duration-500">
              <Briefcase class="w-6 h-6" />
            </div>
            <span class="block text-5xl md:text-6xl font-extrabold text-gray-900 tracking-tight tabular-nums mb-3">1000<span class="text-indigo-600 ml-1">+</span></span>
            <span class="block text-gray-500 font-normal leading-relaxed max-w-[220px] mx-auto">High-signal tech roles</span>
          </div>
        </div>

        <!-- Stat 3 -->
        <div class="group flex flex-col items-center text-center p-8 sm:p-10 rounded-3xl bg-gray-50 border border-gray-100 shadow-sm transition-all duration-500 transform hover:-translate-y-2 hover:shadow-md hover:bg-white">
          <div class="relative z-10 flex flex-col items-center">
            <div class="w-14 h-14 mb-6 rounded-2xl bg-violet-100/50 text-violet-600 flex items-center justify-center group-hover:scale-110 group-hover:bg-violet-600 group-hover:text-white group-hover:shadow-lg group-hover:shadow-violet-600/20 group-hover:-rotate-3 transition-all duration-500">
              <Users class="w-6 h-6" />
            </div>
            <span class="block text-5xl md:text-6xl font-extrabold text-gray-900 tracking-tight tabular-nums mb-3">70<span class="text-violet-600 ml-1">+</span></span>
            <span class="block text-gray-500 font-normal leading-relaxed max-w-[220px] mx-auto">Industry insiders ready to refer you</span>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { TrendingUp, Briefcase, Users } from 'lucide-vue-next'
</script>

<style scoped>
</style>
